<!--
 * @Descripttion: 虚拟建造产品定价页面右侧组件
 * @version: 
 * @Author: zouxin
 * @email: 1294644276@qq.com
 * @Date: 2024-12-17 16:08:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-10-09 11:31:11
-->
<template>
  <div class="rightInformation">
    <div>
      <img class="imgClass" @click="goTop" src="~@/assets/img/goTop.png" />
    </div>
    <div>
      <a-popover placement="left" :overlayStyle="{ position: 'fixed' }" :align="{
        offset: [-12, 0]
      }">
        <template #content>
          15872369729
          <img class="right_img" :src="right_img" alt="" @click="copyCode('15872369729')" @mouseover="isHover = true"
            @mouseleave="isHover = false" />
        </template>
        <div>
          <img src="~@/assets/img/rightPhone.png" alt="" style="margin-right: 8px; cursor: pointer" />
        </div>
      </a-popover>
    </div>
    <div>
      <a-popover placement="left" :overlayStyle="{ position: 'fixed' }" :align="{
        offset: [-12, 0]
      }">
        <template #content>
          bicubemotion@163.com
          <img class="right_img" :src="right_img" alt="" @click="copyCode('bicubemotion@163.com')"
            @mouseover="isHover = true" @mouseleave="isHover = false" />
        </template>
        <div>
          <img src="~@/assets/img/rightEmail.png" alt="" style="margin-right: 8px; cursor: pointer" />
        </div>
      </a-popover>
    </div>
    <div>
      <a-popover placement="left" :overlayStyle="{ position: 'fixed' }" :align="{
        offset: [-12, 0]
      }">
        <template #content>
          <div class="popoverCode">
            <div>{{ $t('base.enterpriseWechat') }}</div>
            <div style="height: 100px; width: 100%" class="rqcode">
              <div></div>
            </div>
            <div>{{ $t('base.scanAdd') }}</div>
          </div>
        </template>
        <div>
          <img src="~@/assets/img/rightChat.png" alt="" style="margin-right: 8px; cursor: pointer" />
        </div>
      </a-popover>
    </div>
  </div>
</template>
<script>
/**
 * fix log:
 * 1. 把鼠标移入到按钮,此时如果有滚动,popover会跟随滚动,导致popover位置不正确
 */
import '../index.less'
export default {
  name: 'rightInformation',
  data() {
    return {
      isHover: false,
      right_img: '~@/assets/img/file-copy-line.png',
    }
  },
  watch: {
    isHover: {
      handler(v) {
        // console.log(v, '3333333333')
        if (v) {
          this.right_img = require('@/assets/img/file-copy.png')
        } else {
          this.right_img = require('@/assets/img/file-copy-line.png')
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 锚点回到最顶端
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    // 复制
    copyCode(data) {
      // 创建一个临时的textarea元素
      const textarea = document.createElement('textarea')
      // 设置要复制的文本
      textarea.value = data
      // 将textarea添加到页面中
      document.body.appendChild(textarea)
      // 选中textarea中的文本
      textarea.select()
      // 执行复制命令
      document.execCommand('copy')
      // 移除临时的textarea元素
      document.body.removeChild(textarea)
      // 可以添加复制成功的提示
      this.$message.success(this.$t('tip.copySuccess'))
    },
  },
}
</script>